<div fxLayout="column" fxLayoutGap="20px">
  <app-page-header title="Classificação das Inscrições" variant="responsive-xs">
    <app-export-button (export)="exportar()"></app-export-button>
    <button mat-raised-button color="primary" (click)="verResultadoFase1()" [disabled]="!fase1Consolidada">
      <mat-icon>picture_as_pdf</mat-icon> Resultado da Fase 1
    </button>
    <button mat-raised-button color="primary" (click)="verResultadoFase2()" [disabled]="!fase2Consolidada">
      <mat-icon>picture_as_pdf</mat-icon> Resultado da Fase 2
    </button>
    <button mat-raised-button color="accent" [routerLink]="['/resumo-classificacao', idConcurso]">
      <mat-icon>summarize</mat-icon> Resumo Classificação
    </button>
  </app-page-header>
  <h2>{{concursoTitulo}}</h2>

  <mat-card *ngIf="retificado" class="card-warning" style="margin-bottom: 16px;">
    <span>⚠️ A classificação gerada pelo sistema foi retificada pela unidade em decorrência de recurso deferido. Consultar os andamentos do concurso para o resultado definitivo.</span>
  </mat-card>

  <mat-form-field appearance="outline" display="inline-block">
    <mat-label>Filtrar</mat-label>
    <mat-select [(value)]="filtro" (valueChange)="selecionar()">
      <mat-option value="TODOS">TODOS</mat-option>
      <mat-option value="NAO_AVALIADO">Não avaliado</mat-option>
      <mat-option value="NAO_HABILITADO">Não habilitado</mat-option>
      <mat-option value="HABILITADO">Habilitado</mat-option>
      <mat-option value="CLASSIFICADO">Classificado</mat-option>
      <mat-option value="NAO_CLASSIFICADO">Não classificado</mat-option>
    </mat-select>
  </mat-form-field>

  <app-search-input #searchInput></app-search-input>

  <div>
    <h3 class="title">
      <mat-icon>list</mat-icon>
      Classificação Ampla Concorrência
    </h3>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let row" class="nowrap">
          {{ row.nomeSocial || row.nome }}
          <img *ngIf="row.pcd != null" src="assets/icons/Accessibility_logo.png" class="accessibility-icon" matTooltip="Pessoa com Deficiência" alt="Pessoa com Deficiência">
        </td>
      </ng-container>
      <ng-container matColumnDef="cpf">
        <th mat-header-cell *matHeaderCellDef>CPF</th>
        <td mat-cell *matCellDef="let row"><span class="nowrap">{{ row.cpf }}</span></td>
      </ng-container>
      <ng-container matColumnDef="situacao">
        <th mat-header-cell *matHeaderCellDef>Inscrição</th>
        <td mat-cell *matCellDef="let row" [innerHTML]="row.situacao?.replace(' (', '<br>(') ?? ''"></td>
      </ng-container>
      <ng-container matColumnDef="pago" *ngIf="mostrarColunaPago">
        <th mat-header-cell *matHeaderCellDef>Pago</th>
        <td mat-cell *matCellDef="let row">{{ row.pago ? 'Sim' : 'Não' }}</td>
      </ng-container>
      <ng-container matColumnDef="classificacao">
        <th mat-header-cell *matHeaderCellDef>Classificação</th>
        <td mat-cell *matCellDef="let row">{{ row.classificacao | uppercase }}</td>
      </ng-container>
      <ng-container matColumnDef="motivo">
        <th mat-header-cell *matHeaderCellDef>Motivo</th>
        <td mat-cell *matCellDef="let row">
          {{ row.motivo }}
          <button *ngIf="getReportesPorInscricao(row.id).length" mat-icon-button
            (click)="abrirHistoricoReporte(row.id)"
            matTooltip="Histórico de reporte de identificação"
            style="vertical-align: middle;">
            <mat-icon [color]="getReporteIconColor(row.id)" [style]="getReporteIconStyle(row.id)">warning</mat-icon>
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="posicao">
        <th mat-header-cell *matHeaderCellDef>Posição</th>
        <td mat-cell *matCellDef="let row">{{ row.posicao }}</td>
      </ng-container>
      <ng-container matColumnDef="autor">
        <th mat-header-cell *matHeaderCellDef>Autor</th>
        <td mat-cell *matCellDef="let row">{{ row.autor }}</td>
      </ng-container>
      <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let row">{{ row.data | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="colunasGrid.length">
          <app-table-no-data [searchValue]="searchInput.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator [length]="totalElements"></app-default-paginator>
  </div>

  <div *ngIf="dataSourcePcd.data.length > 0">
    <h3 class="title">
      <img src="assets/icons/Accessibility_logo.png" class="accessibility-icon" alt="Acessibilidade">
      Classificação PCD
    </h3>
    <table mat-table [dataSource]="dataSourcePcd" matSort>
      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let row">{{ row.nomeSocial || row.nome }}</td>
      </ng-container>
      <ng-container matColumnDef="cpf">
        <th mat-header-cell *matHeaderCellDef>CPF</th>
        <td mat-cell *matCellDef="let row"><span class="nowrap">{{ row.cpf }}</span></td>
      </ng-container>
      <ng-container matColumnDef="situacao">
        <th mat-header-cell *matHeaderCellDef>Inscrição</th>
        <td mat-cell *matCellDef="let row" [innerHTML]="row.situacao?.replace(' (', '<br>(') ?? ''"></td>
      </ng-container>
      <ng-container matColumnDef="pago" *ngIf="mostrarColunaPago">
        <th mat-header-cell *matHeaderCellDef>Pago</th>
        <td mat-cell *matCellDef="let row">{{ row.pago ? 'Sim' : 'Não' }}</td>
      </ng-container>
      <ng-container matColumnDef="classificacao">
        <th mat-header-cell *matHeaderCellDef>Classificação</th>
        <td mat-cell *matCellDef="let row">{{ row.classificacao | uppercase }}</td>
      </ng-container>
      <ng-container matColumnDef="posicao">
        <th mat-header-cell *matHeaderCellDef>Posição</th>
        <td mat-cell *matCellDef="let row">{{ row.posicao }}</td>
      </ng-container>
      <ng-container matColumnDef="autor">
        <th mat-header-cell *matHeaderCellDef>Autor</th>
        <td mat-cell *matCellDef="let row">{{ row.autor }}</td>
      </ng-container>
      <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let row">{{ row.data | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasPcd"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasPcd"></tr>
    </table>
  </div>
</div>
